import * as yup from 'yup'
import yupValidation from '../../../lib/yupValidation'

const form = yup.object().shape({
  descricao: yup.string(),
  descricaoResumida: yup.string(),
  riscoId: yup
    .string()
    .nullable()
    .trim()
    .required('Obrigatório'),
  empresaId: yup.string(),
  ativo: yup.boolean(),
  especifica: yup.boolean(),
  mercadoriaBaixoValor: yup.boolean()
})

export const validateForm = yupValidation(form)
